import './FilterSelect.css';

/* Select de filtro que RESERVA su espacio desde el primer paint. Mata el "layout
   inquieto": los selects cuyas opciones vienen de datos NO deben aparecer de la
   nada cuando cargan (empujando la toolbar).

   CLAVE: se monta SIEMPRE (nunca `return null`). Los productos llegan por lotes
   y las opciones de cada atributo (talla/color/…) aparecen en lotes distintos;
   si ocultáramos el select hasta que TENGA opciones, cada uno aparecería de a uno
   a medida que llega su primer dato — justo el bug que esto elimina. Se muestra
   deshabilitado mientras no tiene opciones (o mientras `loading`) y se habilita
   al llegar. Un atributo que la tienda no use queda como select vacío deshabilitado
   — es el precio de garantizar CERO salto, y no aplica a una tienda de ropa.

   ANCHO (S1#2): montarlo siempre reserva su PRESENCIA, no su ANCHO. Medido a
   1440 con la ventana completa de carga (24 s), los selects de Inventario nacían
   del tamaño de su placeholder y se ensanchaban al llegar las opciones:
   categorías 112→146, color 79→123, tallas 82→96. Por eso el ancho se DECLARA
   por sitio con el valor medido ahí: cada toolbar tiene placeholders distintos
   ("Color" contra "Color: todos") y un valor único no sirve para todas. */
export default function FilterSelect({
  value,
  onChange,
  options = [],
  allLabel,
  ariaLabel,
  loading = false,
  allValue = 'all',
  width,                   // ancho DECLARADO en px (valor MEDIDO en el sitio que
                           // lo usa). Sin esto el select nace del tamaño de su
                           // placeholder y se ensancha al llegar las opciones.
  noTruncate = false,      // tallas: se distinguen por el FINAL, no se truncan
}) {
  const disabled = loading || options.length === 0;
  return (
    <select
      className={`ui-filter-select${noTruncate ? ' ui-filter-select--libre' : ''}`}
      /* El ancho viaja como custom property, NO como `style={{width}}`: el estilo
         en línea le gana a cualquier clase y aplastaría el `width:100%` con el que
         la hoja de filtros móvil del POS (F6) estira estos mismos selects. Como
         variable, la cascada sigue mandando y la hoja gana por especificidad. */
      style={width ? { '--fs-w': `${width}px` } : undefined}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      aria-label={ariaLabel}
      disabled={disabled}
    >
      <option value={allValue}>{allLabel}</option>
      {/* Opción como string (talla/color) o {value,label} (categoría con sangría
          para conservar la jerarquía raíz → subcategoría en un select plano). */}
      {options.map((o) => {
        const val = typeof o === 'string' ? o : o.value;
        const label = typeof o === 'string' ? o : o.label;
        return <option key={val} value={val}>{label}</option>;
      })}
    </select>
  );
}
